import React from 'react'
import { Box, Text } from 'grommet'
import styled from 'styled-components'

const TotalInputsBox = styled(Box)`
  display: flex;
  @media (max-width: 350px) {
    display: none;
  }
`

const InputLength = ({ length }) => {
  return (
    <TotalInputsBox
      border={{
        color: 'border',
        size: '1px',
        style: 'solid',
        side: 'all',
      }}
      pad={{ horizontal: '3px', vertical: '2px' }}
      align="center"
      justify="center"
      round="3px"
    >
      <Text size="1.4rem">{length}</Text>
    </TotalInputsBox>
  )
}

export default InputLength
